import React from "react";
import { MultiSelect as Select } from "react-multi-select-component";

const MultiSelect = ({
  options = [],
  state = [],
  setState,
  name,
  preventKeyboardOpen,
  isShowList,
  isDisable,
  ...props
}) => {
  function onChange(e) {
    try {
      setState(e);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      {/* <div className="w-full-k"> */}
        <Select
          labelledBy={`Select ${name}`}
          options={options}
          value={state}
          onChange={onChange}
          disableSearch={preventKeyboardOpen ? true : false}
          overrideStrings={{
            selectSomeItems: name,
          }}
          isDisabled={isDisable}
          disabled={isDisable}
          {...props}
        />

        {isShowList && state?.length > 0 ? (
          <div className="selected-files">
            <ul>
              {state.map((file, index) => (
                <li key={index}>
                  {file.label}{" "}
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      const newState = state.filter(
                        (item) => item.value !== file.value
                      );
                      onChange(newState);
                    }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-x-lg"
                      viewBox="0 0 16 16">
                      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      {/* </div> */}
    </>
  );
};

export default MultiSelect;
